export { default as TableTr } from './TableTr';
export { default as Colors } from './Colors';
export { default as Card } from './Card';



// WEBPACK FOOTER //
// ./src/components/searchResult/index.js